<app-all-krk-list [filterPending]="true"></app-all-krk-list>
